import { render, staticRenderFns } from "./base-header.vue?vue&type=template&id=2d44d21a&scoped=true"
import script from "./base-header.vue?vue&type=script&lang=js"
export * from "./base-header.vue?vue&type=script&lang=js"
import style0 from "./base-header.vue?vue&type=style&index=0&id=2d44d21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44d21a",
  null
  
)

export default component.exports